import React from 'react';
import './Depoimentos.css';
import Slider from './Slider';

function Depoimentos({ onScroll }) {
  return (
    <div className="depoimentos-wrapper">
      <div className='depoimentos-container'>
        <h1>É tanto resultado que não cabe nem aqui nesta página (é sério, o designer tentou colocar, mas não coube):</h1>
        <div><Slider /></div>
        <button className="main-btn" onClick={onScroll}>      QUERO TER MEU TRABALHO APROVADO!</button>
      </div>
    </div>
  );
}

export default Depoimentos;
